import { useState, useRef } from 'react';
import Wave from './wave';
import FeatureValue from './feature_value';

const symbols = {
  CZK: 'Kč',
  EUR: '€',
  USD: '$',
};

const Plan = ({
  plan,
  currency,
  index,
  supportEmail,
  hoveredFeatureIndex,
  setHoveredFeatureIndex,
  features,
  startSettingsUrl,
}) => {
  const [users, setUsers] = useState(plan.name_cs == 'Kapr' ? 2 : 1);
  const featuresEl = useRef(null);
  const symbol = symbols[currency];

  const trialAvailable = true;
  const trialLength = 14;

  const handleFeatureHover = (e) => {
    const element = e.target.closest('.feature');
    const index = [...featuresEl.current.children].indexOf(element);
    setHoveredFeatureIndex(index);
  };

  let variant = plan.user_pricing.filter(
    (i) => (!i['from'] || i['from'] <= users) && (!i['to'] || i['to'] >= users)
  )[0];
  if (!variant) {
    variant = plan;
  }

  let userPrice = Math.round(variant[`${currency.toLowerCase()}`] * 100) / 100;

  let total = userPrice * users;

  if (plan.fixed_price) {
    total = userPrice;
    userPrice = Math.round((userPrice / users) * 100) / 100;
  }

  let userRanges = [];
  plan.user_pricing.forEach((i) => {
    userRanges.push([i.from, i.to]);
  });

  // Add up to 50 users
  if (
    userRanges[userRanges.length - 1][0] < 20 &&
    !userRanges[userRanges.length - 1][1]
  ) {
    const helperCount = userRanges[userRanges.length - 1][0];
    userRanges[userRanges.length - 1][1] = helperCount;

    for (let i = helperCount + 1; i <= 20; i++) {
      userRanges.push([i, i]);
    }
  }

  if (userRanges.length == 0) {
    userRanges = [[1, plan.limits_users]];
  }

  let buttonUrl = `${startSettingsUrl}&plan_id=${plan.id}`;
  if (plan.private_cloud) {
    buttonUrl = `mailto:${supportEmail}?subject=${I18n.t('plan-interest', {
      name: plan[`name_${I18n.locale}`],
    })}`;
  }

  return (
    <div
      key={plan.id}
      className={classNames('plan', {
        blue: index == 0,
        green: index == 1,
        red: index == 2,
        black: index == 3,
      })}
    >
      <div className='head'>
        <div className='title'>{plan[`name_${I18n.locale}`]}</div>
        {plan.description && (
          <div className='description'>{plan[`description_${I18n.locale}`]}</div>
        )}
        <div className='price'>
          <strong>
            {total.toLocaleString('cs', { maximumFractionDigits: 0 })}
          </strong>{' '}
          {symbol}/{I18n.t('month').toLowerCase()}
        </div>
      </div>
      <div className='wave'>
        <Wave />
      </div>
      <div className='inner'>
        <div className='features' ref={featuresEl}>
          {features.map((feature, index) => (
            <div
              key={feature.name}
              className={classNames('feature', {
                hovered: hoveredFeatureIndex == index,
              })}
              onMouseEnter={handleFeatureHover}
            >
              <div className='name'>{feature.name}</div>
              <div className='value'>
                <FeatureValue
                  {...{ feature, userRanges, users, setUsers, plan, variant }}
                />
              </div>
            </div>
          ))}
        </div>
        <div className='btn-wrapper'>
          <a
            className={classNames('btn', {
              blue: index == 0,
              green: index == 1,
              red: index == 2,
              black: index == 3,
            })}
            href={buttonUrl}
          >
            {plan.private_cloud ? (
              <div className='center'>{I18n.t('i-am-interested')}</div>
            ) : (
              <>
                <div className='top'>{I18n.t('activate')}</div>
                {trialAvailable && (
                  <div className='bottom'>
                    {trialLength} {I18n.t('day', { count: trialLength })}{' '}
                    {I18n.t('pricing.free')}
                  </div>
                )}
              </>
            )}
          </a>
        </div>
      </div>
    </div>
  );
};

export default Plan;
